module.exports = __webpack_public_path__ + "img/shenghuo_icon_sousuo.7c81b827.svg";